import { matchPath } from 'react-router-dom';
import { app } from 'cbmms-js/web';

export default { convertToWeappNavType, convertToWeappPage };

function convertToWeappNavType(path, type) {
  if (path.indexOf('/pages/launch') === 0) {
    return 'reLaunch';
  }
  if (path.indexOf('/pages/mall/home/') === 0) {
    return path.indexOf('?') === -1 ? 'switchTab' : 'reLaunch';
  }

  return type;
}

function convertToWeappPage(location = '') {
  const { parseLocation, stringifyLocation } = app;

  if (typeof location === 'string') {
    location = parseLocation(location);
  }
  const pathname = location.pathname;
  let match;

  match = matchPath(pathname, { path: '/launch' });
  if (match) {
    let redirectURL = location.searchData['CB-URL'];

    if (redirectURL) {
      redirectURL = convertToWeappPage(redirectURL);

      if (redirectURL && typeof redirectURL !== 'string') {
        redirectURL = redirectURL[0];
      }
    }

    return stringifyLocation({
      pathname: '/pages/launch',
      searchData: { 'CB-URL': redirectURL },
    });
  }

  match = matchPath(pathname, { path: '/', exact: true });
  if (match) {
    return '/pages/mall/home/mall';
  }
  match = matchPath(pathname, { path: '/mall' });
  if (match) {
    return '/pages/mall/home/mall';
  }

  match = matchPath(pathname, { path: '/cart' });
  if (match) {
    return '/pages/mall/home/cart';
  }

  match = matchPath(pathname, { path: '/mine' });
  if (match) {
    return '/pages/mall/home/mine';
  }

  match = matchPath(pathname, { path: '/order-list/:tab' });
  if (match) {
    return stringifyLocation({
      pathname: '/pages/mall/order/order-master',
      searchData: { tab: match.params.tab },
    });
  }

  match = matchPath(pathname, { path: '/orders/:orderId' });
  if (match) {
    return stringifyLocation({
      pathname: '/pages/mall/order/order-detail',
      searchData: { orderId: match.params.orderId },
    });
  }

  match = matchPath(pathname, { path: '/order-create/:type' });
  if (match) {
    return stringifyLocation({
      pathname: '/pages/mall/order/order-create',
      searchData: location.searchData,
    });
  }

  match = matchPath(pathname, { path: '/products/:code' });
  if (match) {
    if (match.params.code.indexOf('PT') !== -1) {
      return stringifyLocation({
        pathname: '/pages/activity/pt/pt-product-detail',
        searchData: { product: match.params.code },
      });
    } else if (match.params.code.indexOf('SSL') === -1) {
      return stringifyLocation({
        pathname: '/pages/mall/product/product-detail',
        searchData: { product: match.params.code },
      });
    }
  }

  match = matchPath(pathname, { path: '/activities/ssl/share/:code' });
  if (match) {
    if (!location.searchData['gameId']) {
      return stringifyLocation({
        pathname: '/pages/activity/ssl/ssl-share',
        searchData: { code: match.params.code },
      });
    }
  }

  return [
    stringifyLocation({
      pathname: '/pages/mall/web/web',
      searchData: { url: stringifyLocation(location) },
    }),
  ];
}
